export default {
    namespaced: true,
    state: {
        emailToggle: false,
        costSaverToggle: false,
    },
    mutations: {
        SET_EMAIL_TOGGLE(state, payload) {
            state.emailToggle = payload;
        },
        SET_COST_SAVER_TOGGLE(state, payload) {
            state.costSaverToggle = payload;
        }
    },
    actions: {
        setEmailToggle({ commit }, value) {
            commit("SET_EMAIL_TOGGLE", value);
        },
        setCostSaverToggle({ commit }, value) {
            commit("SET_COST_SAVER_TOGGLE", value);
        },
    }
}